import { UUID_REGEX } from '../../../constants';
export const DEEPLINK_KEY = 'deeplinkPath';
export function setDeeplink(deeplinkPath) {
    if (!deeplinkPath || ['/', ''].includes(deeplinkPath)) {
        return;
    }
    sessionStorage.setItem(DEEPLINK_KEY, deeplinkPath);
}
export function getDeeplink(defaultHomePagePath = '/') {
    try {
        new URL(sessionStorage.getItem(DEEPLINK_KEY) || '');
    }
    catch (_error) {
        return sessionStorage.getItem(DEEPLINK_KEY) || defaultHomePagePath;
    }
    return defaultHomePagePath;
}
export function clearDeeplink() {
    sessionStorage.removeItem(DEEPLINK_KEY);
}
export function getOrgFromDeeplink(deepLink, organizations) {
    const uuidsFromDeeplink = deepLink.match(UUID_REGEX);
    if (!uuidsFromDeeplink || !uuidsFromDeeplink.length) {
        return undefined;
    }
    if (!organizations) {
        return undefined;
    }
    const orgFromDeeplink = organizations.find((org) => org.id === uuidsFromDeeplink[0]);
    return orgFromDeeplink;
}
export function getHubFromDeeplink(deepLink, hubs) {
    const deepLinkPaths = deepLink.split('/');
    const presumedHubCode = deepLinkPaths.length >= 4 && deepLinkPaths[2] === 'workspaces'
        ? deepLinkPaths[3]
        : deepLinkPaths[2];
    return hubs === null || hubs === void 0 ? void 0 : hubs.find((hub) => hub.code === presumedHubCode);
}
//# sourceMappingURL=deeplinkHelper.js.map